import type { LinkProps, TextProps } from '@shopify/polaris';
import type { GTooltipProps } from '../GTooltip';

import { Badge, Box, Icon, InlineStack, Text } from '@shopify/polaris';
import { GVariantBadgeTone, GVariantBadgeSize } from './types';
import { CAMPAIGN_BACKGROUND } from '~/constants/campaign';
import { InfoIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { GTextLink } from '../GTextLink';
import { GTooltip } from '../GTooltip';
import { GVariant } from './GVariant';

export interface GVariantBadgeProps {
  variant: string;
  label?: string;
  tone?: 'active' | 'subdued' | 'inactive';
  labelProps?: Partial<TextProps>;
  /**
   * @name: size
   * @type: 'xs' | 'sm' | 'md' | 'lg'
   * @default: 'md'
   * @description: 'xs': 20px | 'sm': 24px | 'md': 28px | 'lg': 32px
   */
  size?: 'xs' | 'sm' | 'md' | 'lg';
  isShowWinner?: boolean;
  linkAction?: LinkProps;
  tooltip?: GTooltipProps;
  hideVariant?: boolean;
}
export const GVariantBadge = ({
  label,
  variant,
  tone,
  isShowWinner,
  size = GVariantBadgeSize.MD,
  labelProps,
  linkAction,
  tooltip,
  hideVariant = false,
}: GVariantBadgeProps) => {
  const { t } = useTranslation();

  const background: string =
    tone === GVariantBadgeTone.ACTIVE
      ? CAMPAIGN_BACKGROUND.ORIGIN
      : tone === GVariantBadgeTone.SUBDUED
        ? CAMPAIGN_BACKGROUND.SUBDUED
        : CAMPAIGN_BACKGROUND.VARIANT;

  return (
    <Box maxWidth="100%">
      <InlineStack gap="200" blockAlign="center" wrap={false}>
        {!hideVariant && (
          <div
            className="Polaris-GVariantBadge"
            style={{ backgroundColor: background, borderRadius: '100%' }}
          >
            <GVariant variant={variant} size={size} tone={tone} />
          </div>
        )}
        {label && (
          <GTextLink linkAction={linkAction}>
            <Text as="h2" variant="headingMd" {...labelProps} truncate>
              {label}
            </Text>
          </GTextLink>
        )}
        {tooltip && (
          <GTooltip {...tooltip}>
            <Icon source={InfoIcon}></Icon>
          </GTooltip>
        )}
        {isShowWinner && (
          <Text as="p" variant="bodySm" fontWeight="semibold">
            <Badge tone="success">{t('Winner')}</Badge>
          </Text>
        )}
      </InlineStack>
    </Box>
  );
};
